export default {
  'mobilization_position': {
    cs: 'Mobilizační poloha',
    en: 'Mobilization Position',
    track: 'mobilization_position_mobilift',
    conflicting: [
      'trendelenburg',
      'reverse_trendelenburg',
      'mobi_lift_handle',
      'folding_of_foot_siderails',
      'folding_of_head_siderails',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'thighrest_adjustment'
    ],
    conditional: [
      {
        conditionalAnimation: 'bed_height_adjustment_down',
        substituteAnimation: 'mobilization_from_min'
      }
    ],
    reverseInOrder: [
      'backrest_adjustment'
    ],
    reversable: false
  },
  'mobilization_from_min': {
    cs: 'Mobilizační poloha',
    en: 'Mobilization Position',
    track: 'mobilization_mobilift_from_min',
    conflicting: [
      'trendelenburg',
      'reverse_trendelenburg',
      'mobi_lift_handle',
      'folding_of_foot_siderails',
      'folding_of_head_siderails',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'thighrest_adjustment'
    ],
    reverseInOrder: [
      'backrest_adjustment'
    ],
  },
  'mobilization_to_min': {
    cs: 'Mobilizační poloha',
    en: 'Mobilization Position',
    track: 'mobilization_mobilift_to_min',
    conflicting: [],
    overrides: [],
  },
  'cpr': {
    cs: 'CPR pozice',
    en: 'CPR',
    track: 'bed_height_max_to_min',
    conflicting: [
      'thighrest_adjustment',
      'cardiac_chair'
    ],
    conditional: [
      {
        conditionalAnimation: 'trendelenburg',
        substituteAnimation: 'trendelenburg_to_min'
      }
    ],
    reverseInOrder: [],
    reversable: false
  },
  'emergency_trendelenburg': {
    cs: 'Emergency Trendelenburg',
    en: 'Emergency Trendelenburg',
    track: 'trendelenburg',
    opposite: 'reverse_trendelenburg',
    conflicting: [],
    reverseInOrder: [],
    conditional: [],
    reversable: false
  },
  'trendelenburg': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg',
    opposite: 'reverse_trendelenburg',
    conflicting: [
      'cardiac_chair',
      'cardiac_chair_from_min',
      'mobilization_position',
      'mobilization_from_min',
    ],
    conditional: []
  },
  'min_to_trendelenburg': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'min_to_trendelenburg',
    conflicting: [],
    overrides: []
  },
  'trendelenburg_to_min': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg_to_min',
    conflicting: [],
    overrides: [],
  },
  'trendelenburg_to_max': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg_to_max',
    conflicting: [],
    overrides: []
  },
  'reverse_trendelenburg': {
    cs: 'Reverzní Trendelenburg',
    en: 'Reverse Trendelenburg',
    track: 'reversetrendelenburg',
    opposite: 'trendelenburg',
    conflicting: [
      'trendelenburg',
      'cardiac_chair',
      'cardiac_chair_from_min',
      'mobilization_position',
      'mobilization_from_min',
    ],
    conditional: []
  },
  'min_to_reversetrendelenburg': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'min_to_reversetrendelenburg',
    conflicting: [],
    overrides: []
  },
  'reversetrendelenburg_to_min': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'reversetrendelenburg_to_min',
    conflicting: [],
    overrides: []
  },
  'reversetrendelenburg_to_max': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'reversetrendelenburg_to_max',
    conflicting: [],
    overrides: []
  },
  'backrest_adjustment30': {
    cs: 'Zvednutí zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest_adjustment30',
    conflicting: []
  },
  'backrest_adjustment45': {
    cs: 'Zvednutí zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest_adjustment45',
    conflicting: []
  },
  'backrest_adjustment65': {
    cs: 'Zvednutí zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest_adjustment65',
    conflicting: []
  },
  'backrest_adjustment30rev': {
    cs: 'Sklopeni zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest_adjustment30rev',
    conflicting: []
  },
  'backrest_adjustment45rev': {
    cs: 'Sklopeni zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest_adjustment45rev',
    conflicting: []
  },
  'backrest_adjustment65rev': {
    cs: 'Sklopeni zádového dílu',
    en: 'Backrest Adjustment',
    track: 'backrest_adjustment65rev',
    conflicting: []
  },
  'thighrest_adjustment': {
    cs: 'Zvedání stehen',
    en: 'Thighrest Adjustment',
    track: 'thightrest_adjustment',
    conflicting: [
      'cardiac_chair',
      'mobilization_position'
    ]
  },
  'bed_height_adjustment_up': {
    cs: 'Zvedání ložné plochy',
    en: 'Bed Height Adjustment up',
    track: 'bed_height_min_to_max',
    opposite: 'bed_height_adjustment_down',
    conflicting: [
      'mobilization_position',
      'mobilization_from_min',
      'cardiac_chair',
      'cardiac_chair_from_min'
    ],
    conditional: []
  },
  'bed_height_adjustment_down': {
    cs: 'Klesání ložné plochy',
    en: 'Bed Height Adjustment down',
    track: 'bed_height_max_to_min',
    opposite: 'bed_height_adjustment_up',
    conflicting: [],
    conditional: []
  },
  'examination_position': {
    cs: 'Vyšetřovací poloha',
    en: 'Examination Position',
    track: 'bed_height_min_to_max',
    conflicting: [],
    conditional: [],
    reverseInOrder: [],
    reversable: false
  },
  'mobi_lift_handle': {
    cs: 'Mobi-Lift',
    en: 'Mobi-Lift',
    track: 'mobilift',
    conflicting: ['mobilization_position']
  },
  'folding_of_foot_siderails': {
    cs: 'Středová postranice dolů',
    en: 'Folding of Foot Siderails',
    track: 'folding_of_foot_siderails',
    conflicting: ['mobilization_position']
  },
  'folding_of_head_siderails': {
    cs: 'Hlavová postranice dolů',
    en: 'Folding of Head Siderails',
    track: 'folding_of_head_siderails',
    conflicting: ['mobilization_position']
  },

  'cardiac_chair': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiac_chair',
    conflicting: [
      'trendelenburg',
      'reverse_trendelenburg',
      'mobilization_position',
      'mobilization_from_min',
      'thighrest_adjustment'
    ],
    reverseInOrder: [
      'backrest_adjustment',
    ],
    conditional: [
      {
        conditionalAnimation: 'bed_height_adjustment_down',
        substituteAnimation: 'cardiac_chair_from_min'
      }
    ],
    reversable: false
  },
  'cardiac_chair_from_min': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiac_chair_from_min',
    conflicting: [
      'trendelenburg',
      'reverse_trendelenburg',
      'mobilization_position',
      'mobilization_from_min',
      'thighrest_adjustment'
    ],
    reverseInOrder: [
      'backrest_adjustment',
    ],
    reversable: false
  },
  'cardiac_to_max': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiac_to_max',
    conflicting: []
  },
  'cardiac_to_min': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiac_to_min',
    conflicting: []
  },
  'cardiactrendelenburg_to_max': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiactrendelenburg_to_max',
    conflicting: []
  },
  'cardiactrendelenburg_to_min': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiactrendelenburg_to_min',
    conflicting: []
  },
  'cardiacmax_to_trendelenburg': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiacmax_to_trendelenburg',
    conflicting: []
  },
  'cardiacmax_to_reversetrendelenburg': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiacmax_to_reversetrendelenburg',
    conflicting: []
  },
  'cardiac_to_trendelenburg': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair',
    track: 'cardiac_to_trendelenburg',
    conflicting: []
  },
}
